import { render, staticRenderFns } from "./ReportCustomer.vue?vue&type=template&id=162decf7&"
import script from "./ReportCustomer.vue?vue&type=script&lang=js&"
export * from "./ReportCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports